import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { messages } from '../../../../../i18n';
import { SmallSelectables } from '../../../common/selectable/containers/SmallSelectabes';
import { TextLine } from '../../../common/TextLine';
import { SelectablePlacementOptionWithHandler } from './SelectablePlacementOptionWithHandler';

const Root = styled.div`
  margin-top: ${globalTheme.spacing.md}
`;

export const PlacementOptions: FC = () => {
  const { formatMessage } = useIntl();

  return (
    <Root>
      <TextLine>
        <FormattedMessage {...messages['section.imageOverlay.placementOptions']} />
      </TextLine>
      <SmallSelectables data-test="placement-options-container">
        <SmallSelectables.Item>
          <SelectablePlacementOptionWithHandler
            label={formatMessage(messages['section.imageOverlay.placementOptions.topLeft'])}
            placement="top_left"
          />
        </SmallSelectables.Item>
        <SmallSelectables.Item>
          <SelectablePlacementOptionWithHandler
            label={formatMessage(messages['section.imageOverlay.placementOptions.topRight'])}
            placement="top_right"
          />
        </SmallSelectables.Item>
        <SmallSelectables.Item>
          <SelectablePlacementOptionWithHandler
            label={formatMessage(messages['section.imageOverlay.placementOptions.bottomLeft'])}
            placement="bottom_left"
          />
        </SmallSelectables.Item>
        <SmallSelectables.Item>
          <SelectablePlacementOptionWithHandler
            label={formatMessage(messages['section.imageOverlay.placementOptions.bottomRight'])}
            placement="bottom_right"
          />
        </SmallSelectables.Item>
        <SmallSelectables.Item>
          <SelectablePlacementOptionWithHandler
            label={formatMessage(messages['section.imageOverlay.placementOptions.middle'])}
            placement="middle"
          />
        </SmallSelectables.Item>
      </SmallSelectables>
    </Root>
  );
};
